// extracted by mini-css-extract-plugin
export default {"modalOverlay":"nK-z","modalContent":"oK-z","header":"pK-z","close":"qK-z"};